import { type PagamentoWithDettaglioDTO } from '@framework/api-client/api/inquiries-compile/schemas/pagamentoWithDettaglioDTO.ts';
import { EnumCodStatoPagamento } from '../../burden/payments/EnumCodStatoPagamento.tsx';

interface DeletePaymentButtonProps {
  payment: PagamentoWithDettaglioDTO;
}

const CanDeletePaymentStatus: string[] = [
  EnumCodStatoPagamento.DA_PAGARE,
  EnumCodStatoPagamento.FALLIMENTO,
];

export function DeletePaymentButton(props: DeletePaymentButtonProps) {
  // Manca l'endpoint API
  // Al momento non è implementata la cancellazione di un pagamento
  return null;
}
